export function handleFilter(fiterTable, allData, event) {
  Object.assign(fiterTable, event);
  if (Object.keys(fiterTable).length === 0) {
    return allData;
  }
  const result = allData.filter((objeto) => {
    for (const key in fiterTable) {
      if (objeto[key] !== fiterTable[key]) {
        const objectValue = objeto[key].toUpperCase();
        const filterValue = fiterTable[key].toUpperCase();
        if (objectValue !== filterValue && !objectValue.includes(filterValue)) {
          return false;
        }
      }
    }
    return true;
  });
  return result;
}
